module.exports = [{"label":"Solicitar VeloeTag","link":"/minha-veloe/:id/identificadores/nova-tag","id":"menuSummary"},{"label":"Meus Pedidos","link":"/minha-veloe/:id/identificadores/acompanhar-pedido","id":"menuMeusPerdidos"},{"label":"Ativar novo veículo","link":"/identificadores/ativacao","id":"menuAtivar"},{"label":"Como instalar","link":"/minha-veloe/:id/instalacao","id":"menuInstalar"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/TemplateDashboard/linksVeloeTags.json
// module id = 1860
// module chunks = 0